module.exports = __webpack_public_path__ + "img/instagram.90c686e8.svg";